import * as yup from 'yup';

const changePasswordFormSchema = yup.object().shape({
  currentPassword: yup.string().required('Current password is mandatory'),
  newPassword: yup
    .string()
    .required('New password is mandatory')
    .matches(
      /^(?!\s+)(?!.*\s+$)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[$^*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ])[A-Za-z0-9$^*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ]{8,256}$/,
      'Your password must contain at least 8 characters, 1 uppercase letter, 1 number (0-9), 1 special character'
    ),
  confirmPassword: yup
    .string()
    .required('Confirm password is mandatory')
    .oneOf([yup.ref('newPassword')], 'Passwords do not match'),
});

export default changePasswordFormSchema;
